import React, { useContext } from 'react';
import { ConfirmModal, DialogBox } from '@mummssoftware/common-ui';
import { useIntl } from 'react-intl';
import defaults from '../../translations/en.json';
import { HopeContext } from '../Context/HopeWidgetContext';

type ConfirmApprovalProps = {
  onClickCancel: any;
  showConfirm: boolean;
};

export const ConfirmApproval = ({
  onClickCancel,
  showConfirm,
}: ConfirmApprovalProps) => {
  const { patientHopeDocData } = useContext(HopeContext);
  const intl = useIntl();
  const numberOfErrors =
    patientHopeDocData &&
    patientHopeDocData.filter(
      (row: any) => !(row.balwayshide === 'true') && row.errorlevel === 2,
    );
  return (
    <DialogBox
      open={showConfirm}
      handleClick={onClickCancel}
      disableScrollLock
      maxWidth="sm"
      title={defaults.ConfirmApproval}
      contentStyle={{
        padding: '0px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ConfirmModal
        onOKClick={onClickCancel}
        okText={defaults.cancel}
        okButtonColor="secondary"
        modalText=""
        content={
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'large', textDecoration: 'underline' }}>
              {defaults.CMSWarning}
            </div>
            {numberOfErrors?.length && (
              <div>
                {intl.formatMessage(defaults.CMSErrors, {
                  numberOfErrors: numberOfErrors.length,
                })}
              </div>
            )}
          </div>
        }
      />
    </DialogBox>
  );
};
